export class CajeroCaja{
    public constructor(
        
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public cajero_id: String = "",
        public caja_id: String = "",
        public usuario_id: String = "",
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/cajero-caja.ts